module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic15.fa1e8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic15.png
// module id = 480
// module chunks = 1